import { call, put, takeLatest } from "redux-saga/effects";

import menuData from "api/ui/menu";

import { SAVE_FILTERED_MENU, SAVE_USER_INFO, SAVE_USER_ROLES, SAVE_USER_MODULES } from "../actions/actionConstants";
import { checkPermissions, permissions } from "../utils/users";
import { filterMenuByModules } from "../utils/menuFilter";

const filterSubMenu = (item, userRoles) => {
  let newItem;

  if (item.groupList) {
    newItem = {
      ...item,
      groupList: filterMenuRecursive(item.groupList, userRoles),
    };
  } else if (item.child) {
    newItem = {
      ...item,
      child: filterMenuRecursive(item.child, userRoles),
    };
  } else if (item.link) {
    newItem = checkPermissions(item.link, userRoles) ? item : null;
  } else {
    newItem = item;
  }
  return newItem;
};

const nonEmptyNodeOrLeaf = (item, nextItem) =>
  Boolean(
    item
      && (!item.title || (nextItem && !nextItem.title))
      && (!item.child || item.child.length > 0)
  );

const filterMenuRecursive = (menu, userRoles) => {
  const reversedMenu = [...menu].reverse();
  const reversedFilteredMenu = reversedMenu.reduce((filteredMenu, item) => {
    const filteredItem = filterSubMenu(item, userRoles);
    const nextItem = filteredMenu[filteredMenu.length - 1];
    if (nonEmptyNodeOrLeaf(filteredItem, nextItem)) {
      filteredMenu.push(filteredItem);
    }
    return filteredMenu;
  }, []);
  return reversedFilteredMenu.reverse();
};

function* filterMenu(action) {
  const { userRoles } = action;
  const filteredMenu = yield call(filterMenuRecursive, menuData, userRoles);
  yield put({ type: SAVE_FILTERED_MENU, filteredMenu });
}

/**
 * Filter menu based on modules from subscription API
 */
function* filterMenuByModulesSaga(action) {
  try {
    const { services } = action;

    console.log("Filtering menu by modules from subscription...");

    // Use the menuFilter utility to filter menu
    const filteredMenu = yield call(filterMenuByModules, menuData, services);

    yield put({ type: SAVE_FILTERED_MENU, filteredMenu });
  } catch (error) {
    console.error("Error filtering menu by modules:", error);
    // Fallback to empty menu on error
    yield put({ type: SAVE_FILTERED_MENU, filteredMenu: [] });
  }
}

export default function* uiSaga() {
  yield takeLatest(SAVE_USER_ROLES, filterMenu);
  yield takeLatest(SAVE_USER_MODULES, filterMenuByModulesSaga);
}
